<template>
  <section class="mb-20">
    <div class="text-center mb-12">
      <h2 class="text-3xl font-bold text-gray-900 mb-4">科学可靠的评估基础</h2>
      <p class="text-lg text-gray-600 max-w-2xl mx-auto">
        基于心理学研究的专业量表，全面评估恋爱占有欲的四个核心维度
      </p>
    </div>

    <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
      <!-- 控制欲望 -->
      <div class="card text-center hover:shadow-lg transition-shadow border-psychology-primary/10">
        <div class="p-6">
          <div class="w-16 h-16 bg-psychology-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8 text-psychology-primary">
              <circle cx="12" cy="12" r="10"></circle>
              <circle cx="12" cy="12" r="6"></circle>
              <circle cx="12" cy="12" r="2"></circle>
            </svg>
          </div>
          <h3 class="font-semibold mb-2 text-lg text-psychology-primary">控制欲望</h3>
          <p class="text-sm text-gray-600">
            评估在恋爱关系中对伴侣的控制倾向和监控行为
          </p>
        </div>
      </div>

      <!-- 嫉妒强度 -->
      <div class="card text-center hover:shadow-lg transition-shadow border-psychology-secondary/10">
        <div class="p-6">
          <div class="w-16 h-16 bg-psychology-secondary/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8 text-psychology-secondary">
              <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
            </svg>
          </div>
          <h3 class="font-semibold mb-2 text-lg text-psychology-secondary">嫉妒强度</h3>
          <p class="text-sm text-gray-600">
            测量在恋爱关系中的嫉妒情绪和排他性倾向
          </p>
        </div>
      </div>

      <!-- 情感依赖 -->
      <div class="card text-center hover:shadow-lg transition-shadow border-psychology-accent/10">
        <div class="p-6">
          <div class="w-16 h-16 bg-psychology-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8 text-psychology-accent">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>
          <h3 class="font-semibold mb-2 text-lg text-psychology-accent">情感依赖</h3>
          <p class="text-sm text-gray-600">
            评估对伴侣的情感依赖程度和独立性水平
          </p>
        </div>
      </div>

      <!-- 关系不安 -->
      <div class="card text-center hover:shadow-lg transition-shadow border-psychology-success/10">
        <div class="p-6">
          <div class="w-16 h-16 bg-psychology-success/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8 text-psychology-success">
              <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
            </svg>
          </div>
          <h3 class="font-semibold mb-2 text-lg text-psychology-success">关系不安</h3>
          <p class="text-sm text-gray-600">
            测量在亲密关系中的不安全感和焦虑程度
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DimensionsSection'
}
</script>

